"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Submit Form data to google sheets
 * @param {string} sheetScriptUrl - generated sheet link
 * @param {FormData} data - fields must match Sheet labels
 * @returns {{ isValid: Boolean }} Object
 */
const submitToGoogleSheet = (sheetScriptUrl, data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield fetch(sheetScriptUrl, {
            method: 'POST',
            redirect: 'follow',
            mode: 'no-cors',
            body: data,
        });
        return { isValid: true };
    }
    catch (error) {
        console.error('submitToGoogleSheet ~ error:', error);
        return { isValid: false };
    }
});
exports.default = submitToGoogleSheet;
